// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4220":"07072e2844562115","5106":"07072e2844562115"}[chunkId] + ".css";
};